// models/metrics/metasearchMetrics/google-hotel-ads-ppa/googleHotelAdsPPAMetrics.js

// connectivity
import MetricHotelSuspendedCountGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricHotelSuspendedCount";
import MetricLivePricingConfigIssueCount from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricLivePricingConfigIssueCount";
import MetricLivePricingNotAvailableCount from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricLivePricingNotAvailableCount";
import MetricLivePricingOtherReasonCount from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricLivePricingOtherReasonCount";
import MetricLivePricingTechnicalIssueCount from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricLivePricingTechnicalIssueCount";
import MetricLivePricingNotTriggeredCount from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricLivePricingNotTriggeredCount";
import MetricNoAvailabilityCount from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricNoAvailabilityCount";
import MetricMissedParticipationCount from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricMissedParticipationCount";
import MetricNoPrice from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricNoPriceCount";
import MetricNoLandingPage from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricNoLandingPageCount";
import MetricNoTaxBreakdown from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricNoTaxBreakdownCount";

// conversion
import MetricBookingCountGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/conversion/MetricBookingCount";
import MetricConversionGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/conversion/MetricConversion";
import MetricHotelAverageLeadValueMicrosRateGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/conversion/MetricHotelAverageLeadValueMicrosRate";
import MetricHotelPriceDifferencePercentageRateGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/conversion/MetricHotelPriceDifferencePercentageRate";
import MetricRevenuePerclickGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/conversion/MetricRevenuePerclick";
import MetricRoiGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/performance/MetricRoi";

// performance
import MetricClicksGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/performance/MetricClicks";
import MetricClickShare from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/performance/MetricClickShare";
import MetricCpcGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/performance/MetricCpc";
import MetricCsrGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/performance/MetricCsr";
import MetricCtrGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/performance/MetricCtr";
import MetricGeneratedGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/performance/MetricGenerated";
import MetricImprGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/performance/MetricImpr";
import MetricSpent from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/performance/MetricSpent";

// visibility
import MetricEligImprGha from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricEligImprGha";
import MetricImprShareGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricImprShareGha";
import MetricMissedImprGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricMissedImprGha";
import MetricOpportunity from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricOpportunityCount";
import MetricOtherReasonCount from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricOtherReasonCount";
import MetricParticipationCount from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricParticipationCount";
import MetricParticipationPercentRate from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/connectivity/MetricParticipationPercentRate";
import MetricSearchAbsoluteTopImpressionShareGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricSearchAbsoluteTopImpressionShare";
import MetricSearchBudgetLostAbsoluteTopImpressionShareRateGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricSearchBudgetLostAbsoluteTopImpressionShareRate";
import MetricSearchBudgetLostImpressionShareRateGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricSearchBudgetLostImpressionShareRate";
import MetricSearchBudgetLostTopImpressionShareRateGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricSearchBudgetLostTopImpressionShareRate";
import MetricSearchRankLostAbsoluteTopImpressionShareGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricSearchRankLostAbsoluteTopImpressionShare";
import MetricSearchRankLostImpressionShareGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricSearchRankLostImpressionShare";
import MetricSearchRankLostTopImpressionShareRateGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricSearchRankLostTopImpressionShareRate";
import MetricSearchTopImpressionShareRateGhaPPA from "models/metrics/metasearchMetrics/google-hotel-ads-ppa/visibility/MetricSearchTopImpressionShareRate";

const googleHotelAdsPPAMetrics = [
    // connectivity
    new MetricHotelSuspendedCountGhaPPA(),
    new MetricNoAvailabilityCount(),
    new MetricMissedParticipationCount(),
    new MetricLivePricingConfigIssueCount(),
    new MetricLivePricingNotAvailableCount(),
    new MetricLivePricingOtherReasonCount(),
    new MetricLivePricingTechnicalIssueCount(),
    new MetricLivePricingNotTriggeredCount(),
    new MetricNoPrice(),
    new MetricNoLandingPage(),
    new MetricNoTaxBreakdown(),
    // conversion
    new MetricBookingCountGhaPPA(),
    new MetricConversionGhaPPA(),
    new MetricHotelAverageLeadValueMicrosRateGhaPPA(),
    new MetricHotelPriceDifferencePercentageRateGhaPPA(),
    new MetricRevenuePerclickGhaPPA(),
    new MetricRoiGhaPPA(),
    // performance
    new MetricClicksGhaPPA(),
    new MetricClickShare(),
    new MetricCpcGhaPPA(),
    new MetricCsrGhaPPA(),
    new MetricCtrGhaPPA(),
    new MetricGeneratedGhaPPA(),
    new MetricImprGhaPPA(),
    new MetricSpent(),
    // visibility
    new MetricEligImprGha(),
    new MetricImprShareGhaPPA(),
    new MetricOpportunity(),
    new MetricOtherReasonCount(),
    new MetricParticipationCount(),
    new MetricParticipationPercentRate(),
    new MetricMissedImprGhaPPA(),
    new MetricSearchAbsoluteTopImpressionShareGhaPPA(),
    new MetricSearchBudgetLostAbsoluteTopImpressionShareRateGhaPPA(),
    new MetricSearchBudgetLostImpressionShareRateGhaPPA(),
    new MetricSearchBudgetLostTopImpressionShareRateGhaPPA(),
    new MetricSearchRankLostAbsoluteTopImpressionShareGhaPPA(),
    new MetricSearchRankLostImpressionShareGhaPPA(),
    new MetricSearchRankLostTopImpressionShareRateGhaPPA(),
    new MetricSearchTopImpressionShareRateGhaPPA(),
];

export function findMetricById(metricId) {
    return googleHotelAdsPPAMetrics.find((metricClass) => metricClass.field === metricId);
}

export default googleHotelAdsPPAMetrics;
